import projectSettings from "../assets/Js/projectSettings";
import { callAPI } from "../assets/Js/backendCommunication";
import { getPlainToken } from "../assets/Js/tokenHandler";
import { apiResponseToast } from "../assets/Js/apiResponseToast";

const connectWithStripe = async () => {
  let url = `${projectSettings.baseUrl}/subscriptions/connect`;
  let header = true;
  let type = "POST";
  let token = getPlainToken();
  let data = null;
  let response = "";

  response = await callAPI(url, header, type, JSON.stringify(data), token);

  if (response) {
    console.log("redirect url of stripe:", response);
    apiResponseToast(
      response.status,
      "connectwithstripe",
      response.data.message
    );

    if (response.type === "error") {
    } else if (response.type === "success") {
      console.log("redirect url:", response.data.url);
      window.open(response.data.url, "_blank");
    }
  }
};

export default connectWithStripe;
